// ContactSection.jsx
import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const ContactSection = () => {
  const handleCall = () => {
    // create a temporary link, click it, then clean up
    const a = document.createElement("a");
    a.href = "tel:+420739235235";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <section className="relative px-3 mb-32 lg:px-8 xl:px-20" id="contactSection">
      <div className="w-full bg-white border border-solid shadow-2xl border-neutral-100 rounded-2xl">
        <div className="flex p-5 md:p-8">
          <div className="flex flex-col justify-center w-full">
            <h3 className="text-2xl md:text-3xl">Máte zájem o nový vozík, servis, nebo chcete jen poradit?</h3>
            <p className="mt-5 text-neutral-600">
              Ať už vybíráte vysokozdvižný vozík Clark, řešíte servis, školení řidičů, nebo máte specifický požadavek, můžete se na nás kdykoli obrátit. Společně najdeme řešení, které podpoří váš
              provoz.
            </p>

            <div className="flex flex-wrap gap-2 mt-8 sm:gap-3 sm:mt-5 ">
              <Link to={"/kontakt"} state={{ value: "Prodej a pronájem Clark strojů" }}>
                <Button variant="contained" className="font-semibold normal-case rounded-full w-44 bg-gradient-to-r from-primaryLinearFrom to-primary">
                  Vyplnit formulář
                </Button>
              </Link>
              <Button className="font-semibold normal-case border border-solid rounded-full shadow-sm text-darkerPrimary w-44 bg-white-100" onClick={handleCall}>
                Zavolejte nám
              </Button>
            </div>
          </div>

          <div className="justify-end hidden w-full xlPlus:flex">
            <div className="relative w-[40rem] p-5 h-[25rem] max-h-[calc(100vh-15rem)] xl:p-7 overflow-hidden rounded-lg border border-neutral-100 shadow-[0_0_15px_rgba(0,0,0,0.15)]">
              <img className="object-cover w-full h-full rounded-lg" src="/images/ClarkOverview/clark-kontakt.webp" alt="Obrázek vozíku Clark v akci"></img>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
